module.exports = __webpack_public_path__ + "img/house-black-small.23e253c5.svg";